<template>
  <div
    class="chat-timeline"
    :class="{ 'my-timeline': isReceived, 'other-timeline': !isReceived}"
  >
    <div
      class="message-box"
      :class="{ 'my-message-box': isReceived, 'other-message-box': !isReceived}"
    >
      <!-- メッセージ -->
      <MessageViewParts
        :subject="subject"
        :content="content"
        :isReceived="isReceived"
        :color="color"
      />
      <div
        class="status-box"
        :class="{ 'my-status-box': isReceived, 'other-status-box': !isReceived}"
      >
        <p>
          {{ messageTime }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'
import MessageViewParts from '@/components/BalloonParts/MessageViewParts'
import _ from 'lodash'

export default {
  name: 'MessageBalloon',
  components: {
    MessageViewParts,
  },
  computed: {
    ...mapState('directtalk', [
      'color'
    ]),
    messageTime: function () {
      return (
        this.created.getMonth() +
        1 +
        '/' +
        this.created.getDate() +
        ' ' +
        this.created.getHours() +
        ':' +
        ('00' + this.created.getMinutes()).slice(-2)
      )
    },
  },
  props: ['bcc','cc','from','created','name','to','subject', 'content', 'isReceived'],
}
</script>

<style lang="scss" scoped>
.chat-timeline {
  width: 100%;
  padding: 10px;
  display: flex;
  align-items: space-between;
  overflow-x: visible;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
}
.my-timeline {
  flex-direction: row-reverse;
}
.other-timeline {
  flex-direction: row;
}
.avatar-box {
  width: 40px;
  min-width: 40px;
  height: 96px;
  z-index: 5;
}
.avatar-box > img {
  width: 40px;
  height: 40px;
  border-radius: 30px;
  border: 1px solid #f8f8f8;
  box-shadow: 0 1px 1px #ddd;
  background: #fefefe;
  object-fit: cover;
  z-index: 5;
}
.status-box {
  font-size: 12px;
  color: #666;
}
.my-status-box {
  margin-right: 12px;
  p {
    text-align: end;
  }
}
.other-status-box {
  margin-left: 12px;
  p {
    text-align: left;
  }
}
.message-box {
  width: 100%;
}
.my-message-box {
  margin-top: 16px;
  margin-right: -20px;
  width: calc(100% - 40px);
}
.other-message-box {
  margin-top: 16px;
  margin-left: -20px;
  width: 100%;
}
.edit-btn {
  padding: 0;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  margin-top: 8px;
  z-index: 10;
  border: solid 1.5px #a22;
  color: #a22;
}
.target-name {
  background-color:burlywood;
  border-radius: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/MessageBalloon.vue